import React from "react";

// reactstrap misc
import {
    Card,
    CardHeader,
    CardBody,
    CardTitle,
    Button,
    Row,
    Col,
    DropdownItem,
    UncontrolledDropdown,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";
import CoreEngine from "../../core/CoreEngine";
import RequestEngine from "../../core/RequestEngine"
import {connect} from "react-redux";
import loadingAction from "../../core/redux/actions/loadingAction";
import ReactTable from "react-table";
import Constants from "../../core/Constants";
import {confirmAlert} from "../../components/Confirm";

class PaymentList extends CoreEngine {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            dataSource: [],
        };
        this.pathname = "payment";
        this.engine = new RequestEngine();
    }

    componentDidMount() {
      //  this.callPage()
    }



    async handleDelete(valueid) {
        confirmAlert({
            title: 'Delete ',
            message: 'Are you sure to want to delete  ?',
            buttons: [
                {
                    label: 'Yes',
                    className:"redmin",
                    onClick: async () => {

                        this.props.loadingAction(true)
                        const result = await this.engine.deleteItem(this.pathname,valueid)
                        if(result){
                            this.handlePage();
                        }
                        this.props.loadingAction(false)
                    }
                },
                {
                    label: 'No',
                    onClick: () => {

                    }
                }
            ]
        });


    }


    handleEdit(index,dataid) {
        const data = this.state.dataSource[index].data
        this.props.history.push({
            pathname:'/admin/'+this.pathname+'/edit/'+dataid,
            data
        });

    }

    handleActions(index,item) {

        return (<UncontrolledDropdown>
            <DropdownToggle
                aria-expanded={false}
                aria-haspopup={true}
                caret
                className="btn-round btn-block"
                color="primary"
                data-toggle="dropdown"
                id="dropdownMenuButton"
                type="button"
            >
                Actions
            </DropdownToggle>
            <DropdownMenu>

                <DropdownItem  eventKey="2" onClick={() => this.handleEdit(index,item._id)}>Edit</DropdownItem>

                <DropdownItem variant="danger" eventKey="1" onClick={() => this.handleDelete(item._id)}>Delete</DropdownItem>

            </DropdownMenu>
        </UncontrolledDropdown>)
    }






    async callPage() {

        const response = await  this.engine.getItem(this.pathname);

        if(response && response.status === 200){
            this.setState({ // cname,cemail,cposition,cdesc,category,nationality,address,website
                    isLoading: false,
                    dataSource: response.data.data.map((item, key) => {
                        return {
                            id: key,
                            data:item,
                            name: item.title ,
                            status:item.status,
                            expert: item.user && item.user.first+" "+item.user.last ,
                            request: item.request && item.request.title ,
                            created:this.renderDate(item.createdAt),
                            actions: (
                                // we've added some custom button actions
                                this.handleActions(key,item)
                            )
                        };
                    })
                }
            );
        }
        this.props.loadingAction(false);
    }

    handlePage() {
        this.props.loadingAction(true);
        this.callPage()
    }


    handleAdd() {
        this.props.history.push('/admin/'+this.pathname+'/add');
    }


    render() {
        const {dataSource,isLoading} = this.state;

        let columns = [
            {
                Header: "Title",
                accessor: "name"
            },
            {
                Header: "request",
                accessor: "request"
            },
            {
                Header: "expert",
                accessor: "expert"
            },
            {
                Header: "status",
                accessor: "status"
            },


            {
                Header: "Created",
                accessor: "created"
            },
            {
                Header: "Actions",
                accessor: "actions",
                sortable: false,
                filterable: false
            }
        ]


        return (
            <>

                <div className="content">
                    <Row>
                        <Col md="12">
                            <Card>

                                <CardHeader>
                                    <CardTitle tag="h4" className="pull-left">No Payment history found</CardTitle>
<br/>
                                </CardHeader>
                                <br/>
                            </Card>
                        </Col>
                    </Row>

                </div>
            </>
        );
    }
}



const mapDispatchToProps = dispatch => ({
    loadingAction: (payload) => dispatch(loadingAction(payload))
});
export default connect(null, mapDispatchToProps)(PaymentList);
